import { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { supabase } from '@/lib/supabase/client';
import { Logo } from '@/components/ui/Logo';

export default function AuthCallbackPage() {
  const history = useHistory();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // detectSessionInUrl: true exchanges the code automatically on page load.
    // We just wait for onAuthStateChange to fire and then redirect.
    const { data: sub } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        // Check if the user needs to claim a handle
        const { data: profile } = await supabase
          .from('profiles')
          .select('handle')
          .eq('id', session.user.id)
          .single();

        sub.subscription.unsubscribe();
        if (!profile || profile.handle === null) {
          history.replace('/auth/claim-handle');
        } else {
          history.replace('/');
        }
        return;
      }

      if (event === 'TOKEN_REFRESHED') {
        sub.subscription.unsubscribe();
        history.replace('/');
      }
    });

    // Fallback: if no event fires after 8s, something went wrong
    const timeout = setTimeout(() => {
      setError('The sign-in link may have expired. Please request a new one.');
    }, 8000);

    return () => {
      sub.subscription.unsubscribe();
      clearTimeout(timeout);
    };
  }, [history]);

  return (
    <IonPage>
      <IonContent scrollY={false}>
        <div className="flex min-h-full flex-col items-center justify-center bg-[#faf9f7] px-6 py-16">
          <div className="flex flex-col items-center gap-6">
            <Logo size="md" />
            {error ? (
              <div className="text-center">
                <p className="mb-4 text-sm text-red-600">{error}</p>
                <a href="/auth" className="text-sm text-[#1a56a0] hover:underline">
                  Back to sign in
                </a>
              </div>
            ) : (
              <>
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-[#2f3e46]" />
                <p className="text-sm text-gray-500">Signing you in…</p>
              </>
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
